var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"VueTables__primary-content"},[_vm._v(_vm._s(_vm.data.client_name))]),_vm._v(" "),_c('div',{staticClass:"VueTables__secondary-content"},[_vm._v(_vm._s(_vm.data.client_prefixed_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }